import React from "react";
import "./Css/Gramsabha.css";

import img1 from "./Images/schooll1.jpg";   
import img2 from "./Images/schooll2.jpg";   
import img3 from "./Images/schooll3.jpg";   
import img4 from "./Images/schooll4.jpg";   
import img5 from "./Images/schooll5.jpg";  


export default function SchoolRuksha() {
  return (
    <section className="gramsabha-section">
      <h2 className="gramsabha-title">शाळेचा माध्यमातून  स्वच्छता संदेश आणि परिसर स्वच्छता संदेश जनजागृती स्वच्छता मशाल आणि सायकल रॅली
</h2>

      <div className="gramsabha-layout">

        {/* LEFT BIG IMAGE */}
        <div className="item item1">
          <img src={img1} alt="" />
         
          
        </div>

        {/* TOP RIGHT - 2 IMAGES */}
        <div className="item item2">
          <img src={img2} alt="" />
        </div>

        <div className="item item3">
          <img src={img3} alt="" />
        </div>

        {/* CENTER BIG IMAGE */}
        <div className="item item4">
          <img src={img4} alt="" />
        </div>

        {/* RIGHT IMAGE */}
        <div className="item item5">
          <img src={img5} alt="" />
        </div>
      </div>
    </section>
  );
}
